/**
 * The `($)` gated-title marker text.
 *
 * `is_gated` is a boolean wire field, so there is no vocabulary to mirror —
 * but the marker label and its tooltip were hand-copied across StoryRow
 * (rows and alternates) and StoryDetail, the same drift `utils/mediaKind.ts`
 * killed for the (YouTube)/(PDF) markers. This module owns the text;
 * `<GatedMarker>` owns the JSX. iOS half: `ios/Kingfisher/GatedMarker.swift`;
 * Android half: `android/.../data/api/GatedMarker.kt` —
 * `backend/tests/test_mirror_parity.py` pins the label across clients so the
 * same story reads identically everywhere.
 */
export const GATED_MARKER_LABEL = '($)';
export const GATED_MARKER_TITLE = 'Paywalled / login required';
